import React from 'react';
import { ArrowRight, Shield, Award, Users } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-black/60 z-10"></div>
        <img
          src="https://images.unsplash.com/photo-1599995903128-531fc7fb694b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc2NzQyMTA1NXww&ixlib=rb-4.1.0&q=85"
          alt="Construction Site"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-4xl">
          <div className="inline-block mb-6">
            <span className="px-6 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full text-white text-sm font-semibold tracking-wide">
              WATERPROOFING SPECIALISTS
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight tracking-tight">
            Waterproofing and
            <br />
            <span className="bg-gradient-to-r from-gray-200 to-gray-400 bg-clip-text text-transparent">
              Construction Expert
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-10 leading-relaxed font-light max-w-3xl">
            Specialized in waterproofing solutions for bathrooms, terraces, balconies, and tanks. Complete construction and structural repair services for your peace of mind.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button
              onClick={scrollToQuote}
              size="lg"
              className="bg-white text-black hover:bg-gray-100 text-lg px-10 py-7 rounded-full font-semibold shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105"
            >
              Get Free Quote
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="border-2 border-white/50 backdrop-blur-md bg-white/5 text-white hover:bg-white hover:text-black text-lg px-10 py-7 rounded-full font-semibold transition-all duration-300 hover:scale-105"
            >
              Explore Services
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
            <Shield className="w-12 h-12 text-white mb-4" />
            <h3 className="text-3xl font-extrabold text-white mb-2">10 Years</h3>
            <p className="text-gray-300 font-light">Industry Experience</p>
          </div>
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
            <Award className="w-12 h-12 text-white mb-4" />
            <h3 className="text-3xl font-extrabold text-white mb-2">300+ Projects</h3>
            <p className="text-gray-300 font-light">Successfully Completed</p>
          </div>
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
            <Users className="w-12 h-12 text-white mb-4" />
            <h3 className="text-3xl font-extrabold text-white mb-2">100% Satisfaction</h3>
            <p className="text-gray-300 font-light">Client Happiness Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;